import React from 'react'
import dayjs from 'dayjs'
import useMobile from './useMobile'

function capitalizeTheFirstLetterOfEachWord(words) {
  let separateWord = words.toLowerCase().split(' ');
  for(let i = 0; i < separateWord.length; i++) {
    separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
    separateWord[i].substring(1);
  }
  return separateWord.join(' ');
}

function FilmForm(props) {
  const {onSubmit, ..._props} = props;

  const [name, setName] = React.useState('');
  const [platforms, setPlatforms] = React.useState([]);
  const [errors, setErrors] = React.useState({});

  function onChangeName(e) {
    setName(e.target.value);
  }

  function onChangePlatforms(e) {
    let v = [...e.target.selectedOptions].map(o => o.value);
    setPlatforms(v);
  }

  function onClick(e) {
    e.preventDefault();

    let errors = {};
    if(name.length === 0)
      errors.name = "Faut choisir le nom d'un film !";
    if(platforms.length === 0)
      errors.platforms = "Faut choisir au moins une plateforme !";

    setErrors(errors);

    if(Object.keys(errors).length === 0) {
      onSubmit({name: capitalizeTheFirstLetterOfEachWord(name), platforms});
      setName('');
      setPlatforms([]);
    }
  };

  return <tr>
    <td>
      <div className="input-group has-validation">
        <input type="text" className={"form-control"+(errors.name ? ' is-invalid':'')} value={name} onChange={onChangeName} id="name" placeholder="Nom du film"/>
        {errors.name && <div id="validationServerUsernameFeedback" className="invalid-feedback">
          {errors.name}
        </div>}
      </div>
    </td>
    <td>
      <div className="input-group has-validation">
        <select multiple value={platforms} onChange={onChangePlatforms} className={"form-select"+(errors.platforms ? ' is-invalid':'')}>
          <option>Netflix</option>
          <option>Amazon</option>
          <option>Disney</option>
          <option>OCS</option>
          <option>Salto</option>
          <option>Canal+</option>
          <option>Apple TV</option>
          <option>Paramount</option>
          <option>Max</option>
          <option>Mubi</option>
          <option>Louer</option>
          <option>Autre</option>
        </select>
        {errors.platforms && <div id="validationServerUsernameFeedback" className="invalid-feedback">
          {errors.platforms}
        </div>}
      </div>
    </td>
    <td><button type="button" className="btn btn-primary" onClick={onClick}><i className="bi bi-plus-circle-fill"></i></button></td>
  </tr>
}

function Winner(props) {
  const {winner, results, mesFilms, ..._props} = props;

  const mesFilmsNames = React.useMemo(() => {
    return mesFilms.map(a => a.name);
  }, [mesFilms]);

  const res = React.useMemo(() => {
    if(!results)
      return [];

    let res = [];
    for(let round of results) {
      let round_res = {};
      for(let [member, film] of Object.entries(round)) {
        if(mesFilmsNames.includes(film)) {
          if(film in round_res)
            round_res[film].push(member);
          else
            round_res[film] = [member];
        }
      }
      res.push(round_res);
    }
    return res;
  }, [results, mesFilmsNames]);

  const [showResults, setShowResults] = React.useState(false);

  return <div className="countdown">
    <div className="num5">5</div>
    <div className="num4">4</div>
    <div className="num3">3</div>
    <div className="num2">2</div>
    <div className="num1">1</div>
    <div className="num0">
      <h1>{winner.name}</h1>
      <div>{winner.platforms.join(', ')}</div>
      <div>
        <hr className="mt-4 mb-4"/>
        {results && <div className="mb-2"><button className="btn btn-outline-secondary" type="button" onClick={() => setShowResults(!showResults)}>{showResults ? "Cacher les votes":"Afficher les votes"}</button></div>}
        {showResults && <>
          {res.map((r, i) => {
            return <div>
              <div><b>Round {i+1}</b></div>
              {Object.entries(r).map(([film, members]) => {
                return <>{film} : {members.join(',' )}</>
              })}
              <hr className="mt-2 mb-2"/>
            </div>
          })}
        </>}
      </div>
    </div>
  </div>
}

function SalonPage(props) {
  const {connection, onBack,..._props} = props;

  const mobile = useMobile();

  React.useEffect(() => {
    if(!connection)
      return;

    window.history.pushState({}, '', '?code='+connection.hostCode+(connection.host ? '&host=1':''));
  }, [connection]);

  const [mesFilms, setMesFilms] = React.useState([]);
  const [state, setState] = React.useState(null);

  React.useEffect(() => {
    connection.onUpdateMesFilms(setMesFilms);
    return () => connection.offUpdateMesFilms();
  }, [connection, setMesFilms]);

  React.useEffect(() => {
    connection.onUpdateState(setState);
    return () => connection.offUpdateState();
  }, [connection, setState]);

  if(!state) {
    return <div className="spinner-border" role="status">
      <span className="visually-hidden">Chargement...</span>
    </div>
  }

  if(state.state === 'finished')
    return <Winner winner={state.winner} results={state.results} mesFilms={mesFilms}/>;

  function copy() {
    var copyText = document.getElementById("share");
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(copyText.value);
  }

  return <>
    <div>
      <p>Tu as {connection.host ? 'créé':'rejoint'} le salon : {connection.hostCode}</p>
      <div className="input-group mb-3">
        <input type="text" className="form-control" id="share" value={window.location.origin+window.location.pathname+'?code='+connection.hostCode} disabled readOnly/>
        <div className="input-group-append">
          <button className="btn btn-outline-secondary" type="button" onClick={copy}><i className="bi bi-clipboard"></i></button>
        </div>
      </div>
    </div>

    {state.state === 'error' && <div className="text-danger">
      {state.error}
    </div>}

    {state.state === 'open' && <>
      <hr/>
      <h2>Participants</h2>
      <table className="table">
        <tbody>
          {Object.values(state.members).map(member => <tr key={member.name}>
            <td>{member.name}</td>
            <td>{Object.values(member.films).length} film{Object.values(member.films).length > 1 && 's'}</td>
            {connection.host && <td>{member.ID && <button type="button" className="btn btn-danger" onClick={() => connection.kick(member)}><i className="bi bi-x-circle-fill"></i></button>}</td>}
          </tr>)}
        </tbody>
      </table>

      <hr/>
      <div>
        <h2>Mes films</h2>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">Nom</th>
              <th scope="col">Plateformes</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {mesFilms.map((f, i) => (<tr key={f.name}>
              <td>{f.name}</td>
              <td>{f.platforms.join(', ')}</td>
              <td><button type="button" className="btn btn-danger" onClick={() => connection.supprimer(f.name)}><i className="bi bi-trash-fill"></i></button></td>
            </tr>))}
            {mesFilms.length < 3 && <FilmForm onSubmit={film => connection.ajouter(film)}/>}
          </tbody>
        </table>
      </div>

      <hr/>
      <h2>Paramètres</h2>
      <form>
        <div className="mb-3">
          <label htmlFor="exampleInputEmail1" className="form-label">Tirage au sort / Vote</label>
          <select className="form-select" defaultValue={connection.getSetting('type')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('type', e.target.value):null}>
            <option value="tirage_au_sort">Tirage au sort</option>
            <option value="vote">Vote</option>
          </select>
        </div>

        <div className="mb-3">
          <label htmlFor="exampleInputEmail1" className="form-label">Nombre de films</label>
          <input type="number" min="1" step="1" className="form-control" value={connection.getSetting('nbr_films')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('nbr_films', e.target.value):null}/>
        </div>

        {connection.getSetting('type') === 'vote' && <>
          <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label">Prompt pour résumé</label>
            <textarea className="form-control" value={connection.getSetting('resume_prompt')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('resume_prompt', e.target.value):null}/>
          </div>
          <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label">Prompt pour image</label>
            <textarea className="form-control" value={connection.getSetting('image_prompt')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('image_prompt', e.target.value):null}/>
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={connection.getSetting('infos_titre')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('infos_titre', e.target.checked):null} id="infos_titre"/>
            <label className="form-check-label" htmlFor="infos_titre">
              Afficher le titre
            </label>
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={connection.getSetting('infos_date')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('infos_date', e.target.checked):null} id="infos_date"/>
            <label className="form-check-label" htmlFor="infos_date">
              Afficher la date
            </label>
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={connection.getSetting('infos_duree')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('infos_duree', e.target.checked):null} id="infos_duree"/>
            <label className="form-check-label" htmlFor="infos_duree">
              Afficher la durée
            </label>
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={connection.getSetting('infos_genre')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('infos_genre', e.target.checked):null} id="infos_genre"/>
            <label className="form-check-label" htmlFor="infos_genre">
              Afficher le genre
            </label>
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={connection.getSetting('infos_note')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('infos_note', e.target.checked):null} id="infos_note"/>
            <label className="form-check-label" htmlFor="infos_note">
              Afficher la note
            </label>
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={connection.getSetting('infos_image')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('infos_image', e.target.checked):null} id="infos_image"/>
            <label className="form-check-label" htmlFor="infos_image">
              Afficher l'image
            </label>
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={connection.getSetting('infos_resume')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('infos_resume', e.target.checked):null} id="infos_resume"/>
            <label className="form-check-label" htmlFor="infos_resume">
              Afficher le résumé
            </label>
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={connection.getSetting('infos_resume_chatgpt')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('infos_resume_chatgpt', e.target.checked):null} id="infos_resume_chatgpt"/>
            <label className="form-check-label" htmlFor="infos_resume_chatgpt">
              Afficher le résumé par ChatGPT
            </label>
          </div>
          <div className="form-check mb-3">
            <input className="form-check-input" type="checkbox" checked={connection.getSetting('infos_image_chatgpt')} readOnly={!connection.host} disabled={!connection.host} onChange={connection.host ? e => connection.setSetting('infos_image_chatgpt', e.target.checked):null} id="infos_image_chatgpt"/>
            <label className="form-check-label" htmlFor="infos_image_chatgpt">
              Afficher l'affiche par ChatGPT
            </label>
          </div>
        </>}
      </form>

      <hr/>
      <div>
        <button disabled={!state.ready || state.loading} className="btn btn-success btn-lg d-block" style={{width: '100%'}} onClick={() => connection.submit()}>{connection.getSetting('type') === 'vote' ? 'Voter':'Tirer au sort'}</button>
      </div>
    </>}

    {state.state === 'vote' && <>
      <hr/>
      <h2>Faut voter !</h2>
      <table className="table">
        <tbody>
          {state.films.map(film => <tr key={film.name}>
            <td className={"text-start pt-4 pb-4"+(state.votes?.[connection.name] === film.name ? ' border border-success':'')}>
              <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: mobile ? 'column':null}}>
                <div style={{display:'flex', width: mobile ? null : '50%', flexDirection: mobile ? 'column':null}}>
                  {connection.getSetting('infos_image') && film.image && <div className="me-2" style={{maxWidth: mobile ? null:'50%', flexBasis: '50%'}}>
                    <img alt="Image" src={film.image} style={{maxWidth: '100%'}}/>
                  </div>}
                  {connection.getSetting('infos_image_chatgpt') && film.image_chatgpt && <div className="me-2" style={{maxWidth: mobile ? null:'50%', flexBasis: '50%'}}>
                    <img alt="Image ChatGPT" src={film.image_chatgpt} style={{maxWidth: '100%'}}/>
                  </div>}
                </div>
                <div style={{flexGrow: 1, width: mobile ? null : '50%'}}>
                  {connection.getSetting('infos_titre') && <p><b>{film.name}</b></p>}
                  {connection.getSetting('infos_resume') && film.resume && <p>{film.resume}</p>}
                  {connection.getSetting('infos_resume_chatgpt') && film.resume_chatgpt && <p>{film.resume_chatgpt}</p>}
                  <p>
                    {(connection.getSetting('infos_date') && film.date) ? dayjs(film.date).format('DD/MM/YYYY'):'?'}
                    &nbsp;•&nbsp;
                    {(connection.getSetting('infos_genre') && film.genre) ? film.genre:'?'}
                    &nbsp;•&nbsp;
                    {(connection.getSetting('infos_duree') && film.duree) ? (Math.floor(film.duree/60)+'h '+((film.duree%60)+'').padStart(2, '0')+'min'):'?'}
                    &nbsp;•&nbsp;
                    {(connection.getSetting('infos_note') && film.note) ? film.note:'?'}/10
                  </p>
                </div>
              </div>
              {!film.members.includes(connection.name) && <div className="mt-2">
                <button className="btn btn-success btn-lg d-block" style={{width: '100%'}} disabled={state.votes?.[connection.name] === film.name} onClick={() => connection.vote(film.name)}>Je veux voir ce film !</button>
              </div>}
            </td>
          </tr>)}
        </tbody>
      </table>

      <hr/>
      <button className="btn btn-warning btn-lg d-block mt-2" style={{width: '100%'}} disabled={state.votes?.[connection.name] === false} onClick={() => connection.vote(false)}>Je vote pas.</button>

      <hr/>
      <div>
        <button disabled={!state.ready || state.loading} className="btn btn-success btn-lg d-block" style={{width: '100%'}} onClick={() => connection.submit()}>Afficher le résultat</button>
      </div>

      <hr/>
      <h2>Participants</h2>
      <table className="table">
        <tbody>
          {Object.entries(state.votes).map(([name, film]) => {
            return <tr key={name}>
              <td className="text-start">
                {
                  film === null ?
                    <span className="text-danger">{name} a pas voté !</span>
                    :
                    <span className="text-success">{name} a voté !</span>
                }
              </td>
            </tr>
          })}
        </tbody>
      </table>
    </>}

    <hr/>
    <div className="mt-4">
      <button type="submit" className="btn btn-danger btn-sm" onClick={onBack}>Quitter</button>
    </div>
  </>
}

export default SalonPage